export default "__VITE_PUBLIC_ASSET__94664f6b__"